import { Component } from '@angular/core';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';

@Component({
  selector: 'app-association-entry-note',
  templateUrl: './association-entry-note.component.html',
  styleUrls: ['./association-entry-note.component.scss']
})
export class AssociationEntryNoteComponent {
  permissionType = PermissionTypeEnum;
  tab = 0;

}
